export default "__VITE_PUBLIC_ASSET__aa6b9661__"